import { createContext,useState,useContext } from "react";



//este es el contexto para que funcione el cambio de monedas
const MonedaContext = createContext();

export const MonedaProvider = ({children}) =>{
    const [moneda,setMoneda] = useState("ARS");
    return(
        <MonedaContext.Provider value={{moneda,setMoneda}}>
            {children}
        </MonedaContext.Provider>
    )
}

export const useMoneda = ()=>useContext(MonedaContext);